import { useState } from 'react'

import { Container, IconPassword, StyledInput } from './styles'
import { Icon } from '../Icon'
import { CustomSpinner } from '../CustomSpinner'

export function CustomInput({
  icon,
  size,
  height,
  color,
  isPassword,
  isLoading,
  isDisabled,
  ...props
}) {
  const [isFocused, setIsFocused] = useState(false)
  const [isPasswordVisible, setIsPasswordVisible] = useState(false)

  return (
    <Container
      className="form-control"
      $height={height}
      $size={size}
      $color={color}
      $isFocused={isFocused}
    >
      {isLoading ? (
        <CustomSpinner size={25} />
      ) : (
        icon && (
          <Icon
            iconName={icon}
            size={25}
            color={isFocused ? '#06357a' : ''}
          />
        )
      )}

      <StyledInput
        type={isPassword ? (isPasswordVisible ? 'text' : 'password') : 'text'}
        $isFocused={isFocused}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        disabled={isLoading || isDisabled}
        {...props}
      />

      {isPassword && (
        <>
          {!isPasswordVisible ? (
            <IconPassword
              iconName="EyeClosed"
              size={25}
              onClick={() => setIsPasswordVisible(true)}
            />
          ) : (
            <IconPassword
              iconName="Eye"
              size={25}
              onClick={() => setIsPasswordVisible(false)}
            />
          )}
        </>
      )}
    </Container>
  )
}
